import React from "react";
import "./Works.css";

import Image1 from "../../assets/3dicons/announcement.png";
import Image2 from "../../assets/3dicons/www.png";
import Image3 from "../../assets/3dicons/videocamera.png";
import Image4 from "../../assets/3dicons/gallery.png";
import Image5 from "../../assets/3dicons/gym.png";
import Image6 from "../../assets/3dicons/podcast.png";

const Works = () => {
  return (
    <section id="works">
      <h2 className="workstitle">My Portfolio</h2>
      <span className="worksDesc">
        I take pride in paying meticulous attention to the smallest details.
        This is why I started getting interested in software development. I make
        an effort to stay updated on the latest developments in my field and in
        the world. Allocating time to my personal interests is one of my top
        priorities. If one doesn't dedicate time to themselves, they can never
        achieve productive results. I have a strong interest in visuals and
        videos. I both enjoy and engage in graphic design, which is why I chose
        to pursue it. I also enjoy sports and I'm more of a weightlifter. I have
        a passion for music, and I find pleasure in creating beats and
        manipulating sounds. I conduct game live streams on Twitch. As a hobby,
        I come across some news articles, and I narrate and edit them myself.
      </span>
      <div className="worksImages">
        <img src={Image1} alt="" className="worksImg" />
        <img src={Image2} alt="" className="worksImg" />
        <img src={Image3} alt="" className="worksImg" />
        <img src={Image4} alt="" className="worksImg" />
        <img src={Image5} alt="" className="worksImg" />
        <img src={Image6} alt="" className="worksImg" />
      </div>
      <button className="workBTN">See More</button>
    </section>
  );
};

export default Works;
